import { Col, Row } from "reactstrap";
import { H4, Image, LI, P, UL } from "../../../../AbstractElements";
import { BlogDesigner, Comments, Hits, JolioMark, SingleBlogParagraphs } from "../../../../Constant";
import { UserCommentPropsType } from "../../../../Type/Blog";
import { dynamicImage } from "../../../../Service/DynamicImage";

const UserComment = ({ ImageSrc, userReplay,text }: UserCommentPropsType) => {
  return (
    <>
      <LI>
        <UL className="ms-0">
          <LI>
            <div className="d-flex align-self-center">
              <Image className="align-self-center" src={dynamicImage(`blog/${ImageSrc}`)} alt="Generic placeholder" />
              <div className="flex-grow-1">
                <Row>
                  <Col md="4">
                    <H4 className="blog-title mt-0">{JolioMark}<span> {BlogDesigner}</span></H4>
                  </Col>
                  <Col md="8">
                    <UL className="comment-social float-start float-md-end simple-list d-flex flex-row">
                      <LI><i className="icofont icofont-thumbs-up"></i>02 {Hits}</LI>
                      <LI><i className="icofont icofont-ui-chat"></i>598 {Comments}</LI>
                    </UL>
                  </Col>
                </Row>
                <P>{text}</P>
              </div>
            </div>
          </LI>
        </UL>
      </LI>
      {userReplay && (
        <LI>
          <UL className="ms-5">
            <LI>
              <div className="d-flex">
                <Image className="align-self-center" src={dynamicImage("blog/9.jpg")} alt="Generic placeholder image" />
                <div className="flex-grow-1">
                  <Row>
                    <Col xl="12">
                      <H4 className="blog-title mt-0">{JolioMark}<span> {BlogDesigner}</span></H4>
                    </Col>
                  </Row>
                  <P>{SingleBlogParagraphs}</P>
                </div>
              </div>
            </LI>
          </UL>
        </LI>
      )}
    </>
  );
};

export default UserComment;
